import { render } from "./CardApiForm.vue?vue&type=template&id=fc3064f6&scoped=true"
import script from "./CardApiForm.vue?vue&type=script&lang=js"
export * from "./CardApiForm.vue?vue&type=script&lang=js"

import "./CardApiForm.vue?vue&type=style&index=0&id=fc3064f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3064f6"]])

export default __exports__